import {
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME,
  MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL,
  MODAL_CREATE_LEAD_FORM_PROFILE_CITY,
  MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY,
  MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY,
  MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL,
  MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE,
  MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME,
  MODAL_CREATE_LEAD_FORM_PROFILE_PHONE,
  MODAL_CREATE_LEAD_FORM_PROFILE_STATE,
  MODAL_CREATE_LEAD_FORM_PROFILE_ZIP,
  PORTUGUESE,
  SPANISH,
} from "../i18n/keysTranslations.js";

export const META_INSTANT_FORM_TYPE_MORE_VOLUME = "MORE_VOLUME";
export const META_INSTANT_FORM_TYPE_HIGHER_INTENT = "HIGHER_INTENT";

export const META_INSTANT_FORM_ACTION_VIEW_WEBSITE = "VIEW_WEBSITE";
export const META_INSTANT_FORM_ACTION_BOOK_TIME = "BOOK_ON_WEBSITE";

export const MAX_META_INSTANT_FORM_QUESTIONS = 15;
export const MIN_MULTIPLE_CHOICE_OPTIONS = 2;
export const MAX_MULTIPLE_CHOICE_OPTIONS = 15;

// Shared with the create modal and the recommendation prefill so both
// enforce the same text limits.
export const META_INSTANT_FORM_FIELD_LIMITS = {
  name: 100,
  headline: 60,
  body: 300,
  privacyLinkText: 70,
  buttonText: 60,
  url: 2000,
  question: 100,
};

export const DEFAULT_META_INSTANT_FORM_CONTACT_FIELDS = [
  "FULL_NAME",
  "EMAIL",
  "PHONE",
];

export const META_INSTANT_FORM_CONTACT_FIELD_OPTIONS = [
  { value: "FULL_NAME", label: MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME },
  { value: "FIRST_NAME", label: MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME },
  { value: "LAST_NAME", label: MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME },
  { value: "EMAIL", label: MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL },
  { value: "WORK_EMAIL", label: MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL },
  { value: "PHONE", label: MODAL_CREATE_LEAD_FORM_PROFILE_PHONE },
  { value: "CITY", label: MODAL_CREATE_LEAD_FORM_PROFILE_CITY },
  { value: "STATE", label: MODAL_CREATE_LEAD_FORM_PROFILE_STATE },
  { value: "COUNTRY", label: MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY },
  { value: "ZIP", label: MODAL_CREATE_LEAD_FORM_PROFILE_ZIP },
  { value: "JOB_TITLE", label: MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE },
  { value: "COMPANY_NAME", label: MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY },
];

export const META_INSTANT_FORM_LOCALE_OPTIONS = [
  { value: "ES_LA", label: SPANISH },
  { value: "EN_US", label: ENGLISH },
  { value: "PT_BR", label: PORTUGUESE },
  { value: "FR_FR", label: FRENCH },
  { value: "DE_DE", label: GERMAN },
  { value: "IT_IT", label: ITALIAN },
];

const LOCALE_BY_LANGUAGE_CODE = {
  es: "ES_LA",
  en: "EN_US",
  pt: "PT_BR",
  fr: "FR_FR",
  de: "DE_DE",
  it: "IT_IT",
};

export const resolveMetaInstantFormLocale = (language) => {
  const code = String(language || "")
    .split("-")[0]
    .toLowerCase();
  return LOCALE_BY_LANGUAGE_CODE[code] || "ES_LA";
};

const SCHEDULING_PROVIDERS = [
  { name: "Calendly", domains: ["calendly.com"] },
  {
    name: "HighLevel",
    domains: ["leadconnectorhq.com", "msgsndr.com", "gohighlevel.com"],
  },
  { name: "HubSpot", domains: ["meetings.hubspot.com"] },
];

export const detectSchedulingProvider = (url) => {
  let hostname = "";
  try {
    hostname = new URL(String(url || "").trim()).hostname.toLowerCase();
  } catch {
    return null;
  }

  const provider = SCHEDULING_PROVIDERS.find(({ domains }) =>
    domains.some(
      (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
    )
  );
  return provider?.name || null;
};
